module.exports = __webpack_public_path__ + "img/pay_month.05efa5c4.png";